module.exports = __webpack_public_path__ + "static/media/campaigns-desktop-view.302a6faf.jpg";